export const parseParams = (searchParams, config) => {
  const parsedParams = {};
  const urlSearchParams = new URLSearchParams(searchParams);

  Object.entries(config).forEach(([name, paramConfig]) => {
    const {
      type = 'string',
      default: defaultValue = '',
      coerce,
    } = paramConfig;

    const value = urlSearchParams.get(name);

    if (value === null || value === '') {
      parsedParams[name] = defaultValue;
      return;
    }

    // If a custom transformation function is provided use it
    if (typeof coerce === 'function') {
      parsedParams[name] = coerce(value);
      return;
    }

    // Built-in parsing logic
    switch (type) {
      case 'number': {
        const numValue = parseInt(value, 10);
        parsedParams[name] = Number.isNaN(numValue) ? defaultValue : numValue;
        break;
      }
      case 'boolean':
        parsedParams[name] = value.toLowerCase() === 'true';
        break;
      case 'array':
        parsedParams[name] = value.split(',');
        break;
      case 'string':
      default:
        parsedParams[name] = value;
    }
  });

  return parsedParams;
};
